import _ from 'lodash';
import keyStore from './session/sessionStore';

let historySession = {}; // 历史会话
let lastSession = null; // 上一次登录会话
let loginStatus = {
  // 登录状态
  isLogin: false,
  keyType: 'SecretKey', // SecretKey/QcloudAccount
};

// 保存登陆的会话信息 (节流)
const rememberKeys = _.throttle(() => {
  try {
    if (loginStatus.keyType === 'SecretKey') {
      if (lastSession) {
        delete lastSession.SecretKey;
        if (!lastSession.Remember) {
          // storage.add(lastSessionKey, lastSession, 'session');
          keyStore.saveInfoByEncrypt('lastSession', lastSession, 'session');
          lastSession = null;
        }
      }
      Object.keys(historySession).forEach(SecretId => {
        if (!historySession[SecretId].Remember) {
          delete historySession[SecretId];
        }
        if (historySession[SecretId]) {
          const { Contents } = historySession[SecretId];
          Object.keys(Contents).forEach(AccessPath => {
            if (!Contents[AccessPath].Remember) {
              delete Contents[AccessPath];
            }
          });
        }
      });
    } else if (loginStatus.keyType === 'QcloudAccount') {
      if (lastSession && lastSession.clientId) {
        keyStore.saveOauthInfo(lastSession);
      }
    }

    keyStore.saveInfoByEncrypt('historySession', historySession, 'local');
    keyStore.saveInfoByEncrypt('loginStatus', loginStatus, 'session');
    if (lastSession) {
      keyStore.clearInfo('lastSession');
      const _lastSession = _.cloneDeep(lastSession);
      if (loginStatus.keyType === 'QcloudAccount') {
        delete _lastSession.clientId;
        delete _lastSession.clientToken;
        delete _lastSession.userOpenId;
        keyStore.saveInfoByEncrypt('lastSession', _lastSession, 'session');
      } else {
        keyStore.saveInfoByEncrypt('lastSession', _lastSession, 'local');
      }
    }
  } catch (e) {
    console.log(e);
  }
}, 1000);

// 从本地恢复会话信息
export const restoreKeys = () => new Promise(resolve => {
  Promise.all([
    keyStore.getInfoByDecrypt('historySession'),
    keyStore.getInfoByDecrypt('loginStatus'),
    keyStore.getInfoByDecrypt('lastSession'),
  ]).then(data => {
    [historySession, loginStatus, lastSession] = data;
    if (!historySession) {
      historySession = {};
    }
    if (!loginStatus) {
      loginStatus = {
        isLogin: false,
        keyType: 'SecretKey',
      };
    }
    if (lastSession && lastSession.tmpSecretKey && !loginStatus.isLogin) {
      lastSession = null;
      keyStore.clearInfo('lastSession');
      keyStore.deleteOauthInfo();
    }

    if (loginStatus.keyType === 'QcloudAccount') {
      keyStore.getOauthInfo().then(oauthInfo => {
        Object.assign(lastSession, oauthInfo);
        resolve();
      });
      return;
    }
    resolve();
  });
});

const keyBox = {
  getKeyType() {
    return loginStatus.keyType;
  },
  setKeyType(keyType) {
    loginStatus.keyType = keyType;
  },
  async getLastSession() {
    if (!lastSession) return null;

    let _lastSession = lastSession;

    if (!loginStatus.keyType || loginStatus.keyType === 'SecretKey') {
      const { SecretId, AccessPath } = lastSession;
      if (historySession[SecretId]) {
        const group = _.cloneDeep(historySession[SecretId]);
        const content = group.Contents[AccessPath];
        delete group.Contents;
        _lastSession = _.cloneDeep({ ...content, ...group });
      } else {
        _lastSession = lastSession;
      }

      let SecretKey = '';
      SecretKey = await keyStore.getSecretKey(SecretId);
      _lastSession.SecretKey = SecretKey || '';
    } else {
      const oauthInfo = await keyStore.getOauthInfo();
      _lastSession = { ..._lastSession, ...oauthInfo };
    }
    return _.cloneDeep(_lastSession);
  },
  setLastSession(session) {
    lastSession = session;
  },
  async getSession(SecretId) {
    const session = _.cloneDeep(historySession[SecretId]);
    delete session.Contents;

    let SecretKey = '';
    try {
      SecretKey = await keyStore.getSecretKey(SecretId);
    } catch (error) {
      //
    }

    session.SecretKey = SecretKey || '';
    return _.cloneDeep(session || null);
  },
  getSessionContents(id) {
    return _.cloneDeep(historySession[id].Contents);
  },
  getSessionList() {
    return _.cloneDeep(Object.values(historySession)).reverse();
  },
  addKey(keyInfo) {
    if (!keyInfo || !keyInfo.SecretId) return;
    lastSession = _.cloneDeep(keyInfo);

    const {
      SecretId, SecretKey, AccessPath, Region, Remember,
    } = keyInfo;
    const group = _.cloneDeep(keyInfo);
    delete group.AccessPath;
    delete group.Region;

    if (!historySession[SecretId]) {
      historySession[SecretId] = group;
    }
    delete group.SecretKey;

    if (SecretKey) {
      keyStore.saveSecretKey(SecretId, SecretKey);
    }

    let { Contents } = historySession[SecretId];
    if (!Contents) {
      Contents = {};
    }

    if (AccessPath) {
      Contents[AccessPath] = { AccessPath, Region, Remember };
    }

    historySession[SecretId] = { ...group, Contents };

    rememberKeys();
  },
  // 删除会话操作
  removeKey(item) {
    if (item.Contents) {
      // 删除的是 group
      delete historySession[item.SecretId];
      keyStore.deleteSecretKey(item.SecretId);
    } else {
      // 删除 group 中的一条会话
      this.removeAccessPath(item.SecretId, item.AccessPath);
    }

    // 上一次会话记录为当前要删除的会话，则清空记录
    if (
      lastSession
      && item.SecretId === lastSession.SecretId
      && (item.Contents || item.AccessPath === lastSession.AccessPath)
    ) {
      lastSession = null;
    }
    rememberKeys();
  },
  // 删除会话下的访问路径
  removeAccessPath(secretId, AccessPath) {
    const group = historySession[secretId];
    const { Contents } = group;
    delete Contents[AccessPath];
  },
  updateSession(secretId, key, val) {
    const group = historySession[secretId];
    if (!group || !Object.keys(group).includes(key)) return;

    group[key] = val;
    if (lastSession && lastSession.SecretId === secretId) {
      lastSession[key] = val;
    }
    rememberKeys();
  },
  sessionIsExist(id) {
    if (historySession[id]) {
      return true;
    }
    return false;
  },
  login() {
    loginStatus.isLogin = true;
    rememberKeys();
  },
  logout() {
    if (lastSession && !lastSession.Remember) {
      keyStore.deleteSecretKey(lastSession.SecretId);
    }
    if (loginStatus.keyType === 'QcloudAccount') {
      lastSession = null;
      keyStore.clearInfo('lastSession');
      keyStore.deleteOauthInfo();
    }
    loginStatus.keyType = '';
    // storage.add('keyType', '', 'session');
    if (loginStatus.isLogin) {
      loginStatus.isLogin = false;
      rememberKeys();
    }
  },
  isLogin() {
    return loginStatus.isLogin;
  },
  triggerRememberKeys() {
    rememberKeys();
  },
};

export default keyBox;
